import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-integrations-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './integrations-section.component.html',
  styleUrls: ['./integrations-section.component.scss']
})
export class IntegrationsSectionComponent {
  integrationTrackBy(_index: number, item: { name: string }): string {
    return item.name;
  }

  liveIntegrations = [
    { name: 'Stripe', logo: '/img/integrations/Stripe-Emblem.webp' },
    { name: 'Google Workspace', logo: '/img/integrations/Google__G__logo.svg.webp' },
    { name: 'Dropbox', logo: '/img/integrations/Dropbox_(service)-Logo.wine.svg' }
  ];

  plannedIntegrations = [
    { name: 'Mailchimp', logo: '/img/integrations/mailchimp-logo.webp' },
    { name: 'Slack', logo: '/img/integrations/slack.webp' },
    { name: 'Zapier', logo: '/img/integrations/Zapier-Symbol.webp' }
  ];
}
